import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Contact.scss';

interface FormData {
  name: string;
  email: string;
  phone: string;
  weddingDate: string;
  message: string;
}

const Contact: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    phone: '',
    weddingDate: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Send form data to FormSubmit (free email service)
      const response = await fetch('https://formsubmit.co/bellkeir@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          weddingDate: formData.weddingDate,
          message: formData.message,
          _subject: 'New Wedding Enquiry - Stage Door Weddings',
          _template: 'table'
        })
      });

      if (response.ok) {
        alert('Thank you for your enquiry! We\'ll get back to you within 24 hours.');
        setFormData({
          name: '',
          email: '',
          phone: '',
          weddingDate: '',
          message: ''
        });
      } else {
        alert('There was an error submitting your enquiry. Please try again or email us directly at bellkeir@gmail.com');
      }
    } catch (error) {
      alert('There was an error submitting your enquiry. Please try again or email us directly at bellkeir@gmail.com');
    }
    
    setIsSubmitting(false);
  };

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <motion.div 
          className="contact__header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="contact__title">Get In Touch</h2>
          <p className="contact__subtitle">
            Ready to capture your special moment? Let's discuss your vision.
          </p>
        </motion.div>

        <div className="contact__content">
          <motion.form 
            className="contact__form"
            onSubmit={handleSubmit}
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="form__row">
              <div className="form__group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form__group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form__row">
              <div className="form__group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form__group">
              <label htmlFor="weddingDate">Wedding Date</label>
              <input
                type="date"
                id="weddingDate"
                name="weddingDate"
                value={formData.weddingDate}
                onChange={handleInputChange}
              />
            </div>

            <div className="form__group">
              <label htmlFor="message">Tell us about your wedding *</label>
              <textarea
                id="message"
                name="message"
                rows={5}
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Please describe your vision, requirements, and any specific details..."
                required
              ></textarea>
            </div>

            <button 
              type="submit" 
              className="btn-logo-style contact__submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Enquiry'}
            </button>
          </motion.form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
